/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-SearchBoxExample .ms-SearchBox{margin:0 0 10px 0}\n"}]);